import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { doc, getDoc } from "firebase/firestore"; // No longer needed
// import { useFirebase } from "../../context/Firebase"; // No longer needed
import { CircularProgress, Button, Box, Typography, Snackbar } from "@mui/material"; // Added Snackbar
import DOMPurify from "dompurify";
import "./articles.css"; // Use articles.css for styling
import useArticlesViewModel from "../hooks/useArticlesViewModel"; // New import

const ArticleDetails = () => {
  const { id } = useParams();
  // const { db } = useFirebase(); // No longer needed
  const navigate = useNavigate();

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null); // Managed by ViewModel or local
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity] = useState("error");

  const { getArticleDetails, error: vmError } = useArticlesViewModel();

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      // setError(null); // Managed by ViewModel or local snackbar
      try {
        const fetchedArticle = await getArticleDetails(id);
        if (fetchedArticle) {
          setArticle(fetchedArticle);
        } else {
          setSnackbarMessage("Article not found");
          setSnackbarOpen(true);
          // setError("Article not found"); // Use snackbar instead
        }
      } catch (err) {
        console.error("Error fetching article details:", err);
        setSnackbarMessage("Failed to load article details.");
        setSnackbarOpen(true);
        // setError("Failed to load article details."); // Use snackbar instead
      } finally {
        setLoading(false);
      }
    };
    fetchArticle();
  }, [id, getArticleDetails]); // Removed db from dependencies

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  if (loading)
    return (
      <Box className="article-details-loader" display="flex" justifyContent="center" alignItems="center" height="60vh">
        <CircularProgress />
      </Box>
    );

  if (vmError)
    return (
      <Box className="article-details-error-container" textAlign="center" mt={8} px={2}>
        <Typography variant="h6" color="error" gutterBottom>{vmError.message || vmError}</Typography>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );

  if (!article)
    return (
      <Box className="article-details-error-container" textAlign="center" mt={8} px={2}>
        <Typography variant="h6" color="error" gutterBottom>Article not found.</Typography>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2 }}>
          Go Back
        </Button>
      </Box>
    );

  return (
    <Box className="article-details-container" maxWidth="900px" mx="auto" px={{ xs: 2, sm: 4 }} py={{ xs: 3, sm: 5 }} sx={{ bgcolor: 'var(--card-bg)', borderRadius: '12px', boxShadow: '0 6px 20px rgba(0,0,0,0.1)', color: 'var(--text-primary)' }}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
      <Button
        variant="outlined"
        onClick={() => navigate(-1)}
        sx={{
          mb: 3,
          width: { xs: "100%", sm: "auto" },
          whiteSpace: "nowrap",
        }}
      >
        ← Back 
      </Button>

      <Typography
        variant="h4"
        component="h1"
        mb={3}
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.8rem", sm: "2.4rem" },
          wordBreak: "break-word",
        }}
      >
        {article.title}
      </Typography>

      {article.imageUrl && (
        <Box
          component="img"
          src={article.imageUrl}
          alt={article.title}
          sx={{
            width: "100%",
            maxHeight: { xs: 250, sm: 420 },
            objectFit: "cover",
            borderRadius: "12px",
            mb: 4,
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
          }}
        />
      )}

      <Box
        sx={{
          fontSize: { xs: "1rem", sm: "1.1rem" },
          lineHeight: 1.7,
          color: "#444",
          whiteSpace: "pre-line",
          wordBreak: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.description || "") }}
      />
    </Box>
  );
};

export default ArticleDetails;
